// feedbackLuzes.js
import { nodeRedApi } from '../../services/axios';

let statusDasLuzesFlex35 = [];
let statusDasLuzesFlex8 = [];

export async function getLuzesStatusFlex35() {
  try {
    const response = await nodeRedApi.get('/statusLuzesFlex35');
    // assumindo que o back retorna um array puro
    statusDasLuzesFlex35 = Array.isArray(response.data)
      ? [...response.data]
      : [];

    return statusDasLuzesFlex35;
  } catch (error) {
    console.error('Erro na requisição GET /statusLuzesFlex35:', error);
    return statusDasLuzesFlex35;
  }
}

export async function getLuzesStatusFlex8() {
  try {
    const response = await nodeRedApi.get('/statusLuzesFlex8');
    statusDasLuzesFlex8 = Array.isArray(response.data)
      ? [...response.data]
      : [];

    return statusDasLuzesFlex8;
  } catch (error) {
    console.error('Erro na requisição GET /statusLuzesFlex8:', error);
    return statusDasLuzesFlex8;
  }
}

export { statusDasLuzesFlex35, statusDasLuzesFlex8 };